import {useMemo} from 'react';
import {useQuery} from 'react-query';

export const createGetOneHook = (service, keyId, name, mapPayload = v => v) => {
  return (params) => {
    const relatedKey = useMemo(() => params?.[keyId], [params]);

    const queryConfig = useMemo(() => {
      return {enabled: !!relatedKey};
    }, [relatedKey]);

    return useQuery([relatedKey, name], async () => {
      const {data} = await service.getOne(relatedKey);
      return {
        data: mapPayload(data)
      };
    }, queryConfig);
  };
};
